export default "__VITE_ASSET__BJaEsgcp__"